import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { MessagesService } from '../../app-lite/messages/messages.service';
import { Table }           from '../../app-lite/table/types/table';

@Component({
  selector: 'wor-vehicle-visuals-modal-catalog',
  template: `
    <wor-flipper [side]="activeSide">
      <div front *blockUI="'catalogBlock'">
        <div class="modal-header bg-info d-flex align-items-center">
          <h1>
            <i class="fa fa-car"></i>
            {{ 'VEHICLE_VISUALS_SPACE.VEHICLE_VISUALS_CATALOG' | translate }}
          </h1>
        </div>
        <form class="form-horizontal" novalidate>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <list-box
                  [items]="vehicleVisuals.catalog.data"
                  labelField="en_AU"
                  (onSelect)="vehicleVisuals.select('system', $event)"
                  [title]="'VEHICLE_VISUALS_SPACE.SYSTEM' | translate">
                </list-box>
              </div>
              <div class="col-md-4">
                <list-box
                  [items]="vehicleVisuals.catalog.system?.children"
                  labelField="en_AU"
                  (onSelect)="vehicleVisuals.select('part', $event)"
                  [placeholder]="'VEHICLE_VISUALS_SPACE.SELECT_A_SYSTEM' | translate"
                  [title]="'VEHICLE_VISUALS_SPACE.PART' | translate">
                </list-box>
              </div>
              <div class="col-md-4">
                <list-box
                  [items]="vehicleVisuals.catalog.part?.children"
                  labelField="en_AU"
                  (onSelect)="vehicleVisuals.select('defect', $event)"
                  [placeholder]="'VEHICLE_VISUALS_SPACE.SELECT_A_PART' | translate"
                  [title]="'VEHICLE_VISUALS_SPACE.DEFECT' | translate">
                </list-box>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex align-items-center">
            <button type="button" class="btn btn-cancel"
              (click)="modal.dismiss()"
              translate="GENERAL_SPACE.BUTTON.CANCEL">
            </button>
            <div class="m-left-auto">
              <label class="switch switch-extra-long switch-success margin-top-none">
                <input type="checkbox" class="switch-input"
                  (change)="refreshCatalog()"
                  [(ngModel)]="vehicleVisuals.interactive"
                  [ngModelOptions]="{ standalone: true }">
                <span class="switch-label"
                  [attr.data-off]="'GENERAL_SPACE.SWITCH.NARRATED' | translate"
                  [attr.data-on]="'GENERAL_SPACE.SWITCH.SILENT_VIDEOS' | translate">
                </span>
                <span class="switch-handle"></span>
              </label>
              <button type="button" class="btn btn-info"
                (click)="flip()"
                translate="GENERAL_SPACE.BUTTON.SEARCH">
              </button>
              <button type="button" class="btn btn-success"
                [disabled]="!vehicleVisuals.catalog.system"
                (click)="selectFromCatalog()"
                translate="GENERAL_SPACE.BUTTON.SELECT">
              </button>
            </div>
          </div>
        </form>
      </div>
      <div back>
        <div class="modal-header bg-info d-flex align-items-center">
          <h1>
            <i class="fa fa-car"></i>
            {{ 'VEHICLE_VISUALS_SPACE.VEHICLE_VISUALS_CATALOG' | translate }}
          </h1>
        </div>
        <div class="modal-body">
          <form class="form-horizontal" novalidate>
            <div class="row">
              <div class="col-md-6">
                <label class="control-label"
                  translate="VEHICLE_VISUALS_SPACE.SEARCH_CATALOG">
                </label>
                <div class="controls">
                  <div class="input-group">
                    <input class="form-control focused"
                      name="search" type="text"
                      [(ngModel)]="vehicleVisuals.catalog.search.query">
                    <span class="input-group-btn">
                      <button class="btn btn-info btn-tag"
                        type="button"
                        (click)="search()"
                        [disabled]="!vehicleVisuals.catalog.search.query"
                        translate="GENERAL_SPACE.BUTTON.SEARCH">
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <wor-table
              [(data)]="vehicleVisuals.catalog.search.results"
              [settings]="tableSettings"
              (rowClick)="onRowClick()"
              (rowDoubleClick)="onRowDoubleClick($event)">
            </wor-table>
          </form>
        </div>
        <div class="modal-footer d-flex align-items-center">
          <button type="button" class="btn btn-cancel"
            (click)="modal.dismiss()"
            translate="GENERAL_SPACE.BUTTON.CANCEL">
          </button>
          <div class="m-left-auto">
            <label class="switch switch-extra-long switch-success margin-top-none">
              <input type="checkbox" class="switch-input"
                (change)="vehicleVisuals.getCatalog()"
                [(ngModel)]="vehicleVisuals.interactive"
                [ngModelOptions]="{ standalone: true }">
              <span class="switch-label"
                [attr.data-off]="'GENERAL_SPACE.SWITCH.NARRATED' | translate"
                [attr.data-on]="'GENERAL_SPACE.SWITCH.SILENT_VIDEOS' | translate">
              </span>
              <span class="switch-handle"></span>
            </label>
            <button type="button" class="btn btn-info"
              (click)="flip()"
              translate="VEHICLE_VISUALS_SPACE.CATALOG">
            </button>
            <button type="button" class="btn btn-success"
              [disabled]="!selectedItems.length"
              (click)="selectFromSearch()"
              translate="GENERAL_SPACE.BUTTON.SELECT">
            </button>
          </div>
        </div>
      </div>
    </wor-flipper>
  `
})
export class VehicleVisualsModalCatalogComponent implements OnInit {
  @Input() vehicleVisuals: any;

  @BlockUI('catalogBlock') catalogBlock: NgBlockUI;

  activeSide    = 'front';
  searched      = false;
  selectedItems : any[] = [];
  tableSettings : Table = {};

  constructor (
    public  modal           : NgbActiveModal,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  ngOnInit (): void {
    this.tableSettings = {
      columns: [
        {
          classes: 'text-left',
          field  : 'title',
          header : {
            text: this.translateService.instant('VEHICLE_VISUALS_SPACE.PART')
          }
        },
        {
          classes: 'text-left',
          field  : 'description',
          header : {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
          }
        }
      ],
      empty: {
        text: this.translateService.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        },
        select: {
          enabled: true
        }
      },
      sorting: {
        enabled: false
      }
    };
  }

  flip (): void {
    this.activeSide = this.activeSide === 'front' ? 'back' : 'front';
  }

  onRowClick (): void {
    this.selectedItems = this.vehicleVisuals.catalog.search.results.filter((row: any) => row.selected);
  }

  onRowDoubleClick (event: any): void {
    this.selectedItems = [event.row];
    this.selectFromSearch();
  }

  refreshCatalog (): void {
    this.catalogBlock.start();

    this.vehicleVisuals.getCatalog()
      .finally(() => {
        this.catalogBlock.stop();
      });
  }

  search (): void {
    this.vehicleVisuals.search()
      .then(() => {
        this.searched = true;
      })
      .catch((err: any) => this.messagesService.error(err));
  }

  selectFromCatalog (): void {
    const selection = this.vehicleVisuals.catalog.defect
      || this.vehicleVisuals.catalog.part
      || this.vehicleVisuals.catalog.system;

    this.modal.close(selection);
  }

  selectFromSearch (): void {
    if (this.selectedItems.length) {
      this.modal.close(this.selectedItems[0]);
    }
  }
}
